export default function getResource(label, vars = []) {
    const resources = {
        title: 'Mes adresses enregistrées',
        cancel: 'Annuler',
        confirm: 'Utiliser cette adresse',
        noAddresses: 'Aucune adresse enregistrée',
        showMore: 'Afficher tout',
        showLess: 'Afficher moins',
        defaultLabel: 'Par défaut',
        editLabel: 'Modifier',
        removeLabel: 'Supprimer',
        removeAddressLabel: 'Supprimer l’adresse',
        editAddressLabel: 'Modifier l’adresse',
        addShippingAddress: 'Ajouter une nouvelle adresse'
    };

    return resources[label];
}
